import { cn } from "@/shared/lib/cn";

/** Hairline indeterminate spinner for pending states. Honors reduced motion. */
export interface SpinnerProps {
  /** Diameter in px. Default 18. */
  size?: number;
  className?: string;
  label?: string;
}

export function Spinner({ size = 18, className, label }: SpinnerProps) {
  return (
    <span
      role={label ? "status" : undefined}
      aria-atomic={label ? "true" : undefined}
      aria-hidden={label ? undefined : "true"}
      style={{ width: size, height: size }}
      className={cn(
        "studio-spinner inline-block animate-spin rounded-full border-2 motion-reduce:animate-none",
        className,
      )}
    >
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
